import { Component, OnInit } from '@angular/core';
import { BankInfoData } from './bank-info.data';
import { environment } from 'src/environments/environment';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-bank-info',
    templateUrl: './bank-info.component.html',
    styleUrls: ['./bank-info.component.css']
})
export class BankInfoComponent implements OnInit {
    public production: boolean = environment.production;

    public bankInfo: BankInfoData = new BankInfoData(this.formBuilder);
    public states: any[] = [];
    public bankTypes: any[] = [];

    private applicationId: number;

    submitted = false;

    constructor(
        private connectionService: ConnectionService,
        public router: Router,
        private formBuilder: FormBuilder
    ) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.applicationId = navigation.extras.state.applicationId;
        } else {
            this.router.navigateByUrl('/');
        }
    }

    ngOnInit() {
        this.getStates().then(
            (statesData: any) => {
                this.getBankTypes().then(
                    (bankTypesData: any) => { },
                    (bankTypesError: any) => { }
                );
            },
            (statesError: any) => {
                this.getBankTypes().then(
                    (bankTypesData: any) => { },
                    (bankTypesError: any) => { }
                );
            }
        );
    }

    get form () { return this.bankInfo.form.controls; }

    getStates() {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(environment.gateway + 'utils/states', 'application/json').subscribe(
                (data: any) => {
                    this.states = data.object;
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    getBankTypes() {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'utils/bankTypes', 'application/json').subscribe(
                (data: any) => {
                    this.bankTypes = data.object;
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    uploadBankInfo() {
        this.submitted = true;
    
        if (this.bankInfo.form.invalid) {
          return;
        }

        const promise = new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'application/bankinfo/' + this.applicationId,
                this.getBankinfoData(), 'application/json').subscribe(
                    (data: any) => {
                        this.router.navigateByUrl('/application/docuSign', { state: { applicationId: this.applicationId } });
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }

    getBankinfoData() {
        return this.bankInfo.encode();
    }

    onCompleteInformationClick() {
        this.bankInfo.decode(
            {
                accountName: 'Audio visual equipment',
                accountNumber: '1222613232',
                accountNumberConfirm: '1222613232',
                accountRoutingNumber: '121000358',
                accountType: 'CHECKING',
                bankName: 'US Bank association',
                city: 'Bremen',
                state: 'AL'
            }
        );
    }
}
